import React from 'react';
import T from 'prop-types';
import cx from 'classnames';

const WarningNotification = ({ text, className }) => (
  <div className={cx('warning-notification', className)}>
    <span className="hicon-warning" />
    <p>{text}</p>
  </div>
);

WarningNotification.propTypes = {
  text: T.node.isRequired,
  className: T.string,
};

export default WarningNotification;
